import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { colorMuted, colorWhite, colorSecondaryTint8, hex2rgba } from "../../colors";
import { setThemeColor } from "../../setThemeColor";
import { setTextColor } from "../../setTextColor";
import { MenuProps, MenuItem, MenuSubTitle, MenuDivider } from "./Menu.types";

type StyledMenuProps = Pick<MenuProps, "theme" | "variant">;
type StyledMenuItemProps = Pick<MenuItem, "theme" | "variant">;
type StyledMenuSubTitle = Pick<MenuSubTitle, "theme" | "variant">;


export const StyledMenuContainer = styled.ul.attrs({
  className: 'menu'
})<StyledMenuProps>`
  ${typographyMixin}
  font-size: 0.95rem;
  display: inline-block;

  background-color: ${(props) =>
    props.variant === "inverted"
      ? props.theme.primaryColor
      : "#fff"};
  padding: 0.375rem 0;
  min-width: 200px;
  max-width: 250px;
  margin: 0;
`;

export const StyledMenuItem = styled.li.attrs({
  className: 'menu-item'
})<StyledMenuItemProps>`
  list-style-type: none;
  padding: 0.375rem 1.65rem;
  margin: 0;
  color: ${(props) =>  props.theme.textOnPrimaryColor};


  &:hover {
    background-color: ${(props) =>
       props.variant === "inverted"
        ? props.theme.muted
        : props.theme.primaryColor};
    filter: brightness(0.9);
    cursor: pointer;
  }

  .description {
    font-size: 0.75rem;
    color: ${(props) =>
      props.variant === "inverted"
      ? hex2rgba(props.theme.textOnPrimaryColor, 0.9) 
      : hex2rgba("#36383D", 0.9)};
    
    img {
      width: 32px;
    }
  }
`;

export const StyledMenuDivider = styled.div.attrs({
  className: 'menu-divider'
})<MenuDivider>`
  height: 1px;
  margin: 0.375rem 0;
  background-color: ${(props) =>
    props.variant === "inverted" ? "#36383D" : props.theme.primaryColor};
  color: ${(props) =>
    props.variant === "inverted" ? "#36383D" : props.theme.textOnPrimaryColor};
  filter: brightness(0.8);
  &:last-child {
    display: none;
  }
`;

export const StyledMenuSubtitle = styled.div.attrs({
  className: 'menu-subtitle'
})<StyledMenuSubTitle>`
  font-size: 0.8rem;
  padding: 0.375rem 1.65rem 0 1.65rem;
  color: ${(props) =>
   props.variant === "inverted" 
      ? props.theme.textOnSecondaryColor
      : hex2rgba(props.theme.textOnPrimaryColor, 0.6)};

  text-transform: uppercase;
`;
